import auth from '@/router/auth'
import CourseIndex from '@/components/projects/Index'
import CourseCreate from '@/components/projects/Create'
import CourseUpdate from '@/components/projects/Update'
import CourseShow from '@/components/projects/Show'

export default [
  {
    path: '/projects',
    name: 'projects-index',
    component: CourseIndex,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/projects/create',
    name: 'projects-create',
    component: CourseCreate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/projects/update/:course_id',
    name: 'projects-update',
    component: CourseUpdate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/projects/show/:course_id',
    name: 'projects-show',
    component: CourseShow,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/projects/router.js